module.exports = __webpack_public_path__ + "static/media/gradient.e2bcdbee.svg";